import PasswordLengthCounter from "./password_length_counter";
import PasswordStrengthMeter from "./password_strength_meter";
import ShowPasswordToggle from "./show_password_toggle";

class PasswordInputComponent {
    private $lengthCounter: PasswordLengthCounter | null;
    private $strengthMeter: PasswordStrengthMeter | null;
    private $showPasswordToggle: ShowPasswordToggle | null;

    constructor(document: Document, blockListInputSelectors: Map<string, string>) {
        this.$lengthCounter = new PasswordLengthCounter(document);
        this.$lengthCounter.registerEventListeners();

        this.$showPasswordToggle = new ShowPasswordToggle(document);
        this.$showPasswordToggle.registerEventListeners();

        this.$strengthMeter = new PasswordStrengthMeter(document, blockListInputSelectors);
        this.$strengthMeter.registerEventListeners();
    }
}

export default PasswordInputComponent;
